import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { Servers } from './pages/Servers';
import { AddServer } from './pages/AddServer';
import { ServerDetail } from './pages/ServerDetail';
import { PolicyBuilder } from './pages/PolicyBuilder';
import { AuditInbox } from './pages/AuditInbox';
import { SessionDetail } from './pages/SessionDetail';
import { Settings } from './pages/Settings';
function ProtectedRoute({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    isAuthenticated
  } = useAuth();
  if (!isAuthenticated) {
    return <Login data-id="element-0" />;
  }
  return <>{children}</>;
}
function AppRoutes() {
  return <BrowserRouter data-id="element-1">
      <Routes data-id="element-2">
        <Route path="/login" element={<Login data-id="element-4" />} data-id="element-3" />
        <Route path="/*" element={<ProtectedRoute data-id="element-6">
              <Layout data-id="element-7">
                <Routes data-id="element-8">
                  <Route path="/" element={<Servers data-id="element-10" />} data-id="element-9" />
                  <Route path="/servers/new" element={<AddServer data-id="element-12" />} data-id="element-11" />
                  <Route path="/servers/:serverId" element={<ServerDetail data-id="element-14" />} data-id="element-13" />
                  <Route path="/servers/:serverId/policy" element={<PolicyBuilder data-id="element-16" />} data-id="element-15" />
                  <Route path="/audit" element={<AuditInbox data-id="element-18" />} data-id="element-17" />
                  <Route path="/audit/:sessionId" element={<SessionDetail data-id="element-20" />} data-id="element-19" />
                  <Route path="/settings" element={<Settings data-id="element-22" />} data-id="element-21" />
                </Routes>
              </Layout>
            </ProtectedRoute>} data-id="element-5" />
      </Routes>
    </BrowserRouter>;
}
export function App() {
  return <AuthProvider data-id="element-23">
      <AppRoutes data-id="element-24" />
    </AuthProvider>;
}